import { Reveal } from "./shared";

const CHAPTERS = [
  {
    n: "01",
    title: "We show the real numbers",
    body: "$0 revenue. No paying customers or paid pilots yet. Both are printed on this page in plain type, because an investor who cannot trust the bad news cannot trust the good.",
  },
  {
    n: "02",
    title: "Safety AI on cameras that already exist",
    body: "From data centers to utility-scale solar, our six products run on the CCTV, phones and body cameras already in the field — detecting hazards, verifying inductions, and closing the remediation loop.",
  },
  {
    n: "03",
    title: "Small round, sharp milestones",
    body: "$250K is deliberately modest. It funds founding pilots on active jobsites. Evidence first — the $4.5M round follows traction, not the other way around.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
      {CHAPTERS.map((c, i) => (
        <Reveal key={c.n} delay={i * 0.08}>
          <div className="grid grid-cols-1 gap-6 border-t border-slate-800 py-10 md:grid-cols-12 md:py-14">
            <span className="font-mono text-sm text-[#FF5500] md:col-span-2">{c.n}</span>
            <h3 className="font-display text-2xl font-semibold uppercase tracking-tight text-slate-100 sm:text-3xl md:col-span-5">
              {c.title}
            </h3>
            <p className="text-base leading-relaxed text-slate-400 md:col-span-5">{c.body}</p>
          </div>
        </Reveal>
      ))}
    </section>
  );
}
